import { render } from "./AlertVue.vue?vue&type=template&id=f73a0726&scoped=true"
import script from "./AlertVue.vue?vue&type=script&lang=js"
export * from "./AlertVue.vue?vue&type=script&lang=js"

import "./AlertVue.vue?vue&type=style&index=0&id=f73a0726&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f73a0726"]])

export default __exports__